import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, message, Skeleton } from 'antd';
import Currency from '../../../../components/common/Currency';
import {getByEmpleadoId} from '../../../../apis/SaldosEmpleadoApi';

const ModalSaldos = ({ visible, onClose, bajaData, finiquito }) => {
    const [loading, setLoading] = useState(false);
    const [saldosData, setSaldosData] = useState([]);

    // Datos de ejemplo - reemplazar con llamada a API real
    const saldosEjemplo = [
        {
            key: '1',
            tipo_saldo: 'PRESTAMO',
            monto_original: 1500,
            concepto: 65,
            saldo: 5000,
            referencia: ''
        },
        {
            key: '2',
            tipo_saldo: 'AHORRO',
            monto_original: 0,
            concepto: 71,
            saldo: 400,
            referencia: ''
        }
    ];


    const columns = [
      {
        title: 'Periodo',
        dataIndex: 'periodo_clave',
        key: 'periodo_clave',
      },
      {
        title: 'Tipo Saldo',
        dataIndex: 'referencia_tipo_saldo',
        key: 'referencia_tipo_saldo',
      },
      {
        title: 'Saldo Clave',
        dataIndex: 'tipo_saldo_clave',
        key: 'tipo_saldo_clave',
      },
      {
        title: 'Saldo Actual',
        dataIndex: 'saldo_actual',
        key: 'saldo_actual',
        render: (value, object)=> {
          return <Currency value={value} />
        }
      },
      {
        title: 'Concepto',
        dataIndex: 'concepto_tipo_saldo',
        key: 'concepto_tipo_saldo',
      },
    ];

    useEffect(() => {
        console.log(1)
        if (visible && bajaData) {
            cargarSaldos();
        }
    }, [visible, bajaData]);

    const cargarSaldos = async () => {
        if (!bajaData?.odoo_empleado_id) {
            message.error('No se ha seleccionado un empleado válido');
            return;
        }

        setLoading(true);
        debugger;
        try {
            // Aquí deberías hacer la llamada a tu API real
            const response = await getByEmpleadoId(bajaData.odoo_empleado_id);
            if (response.ok) {
                setSaldosData(response.payload);
            } else {
                message.error('Error al cargar los saldos');
            }
            setLoading(false);
        } catch (error) {
            console.error('Error al cargar saldos:', error);
            message.error('Error al cargar los saldos del empleado');
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSaldosData([]);
        onClose();
    };

    return (
        <Modal
            title={`Saldos - ${bajaData?.empleado || 'Empleado'}`}
            open={visible}
            onCancel={handleClose}
            width={700}
            footer={[
                <Button key="close" onClick={handleClose}>
                    Cerrar
                </Button>
            ]}
            destroyOnClose
        >
            <div style={{ marginTop: 16 }}>
                {loading ? (
                    <Skeleton active />
                ) : (
                    <Table
                        dataSource={saldosData}
                        columns={columns}
                        pagination={false}
                        size="small"
                        bordered
                        scroll={{ x: true }}
                        style={{
                            backgroundColor: '#f8f9fa'
                        }}
                        rowClassName={(record, index) => 
                            index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                        }
                    />
                )}
                
                {!loading && saldosData.length === 0 && (
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '20px',
                        color: '#666'
                    }}>
                        No se encontraron saldos para este empleado
                    </div>
                )}
            </div>

            <style jsx>{`
                .table-row-light {
                    background-color: #ffffff;
                }
                .table-row-dark {
                    background-color: #f5f5f5;
                }
            `}</style>
        </Modal>
    );
};

export default ModalSaldos;